import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';
import {Observable} from 'rxjs/Observable';
import {tap} from 'rxjs/operators';

@Injectable()
export class MstVisitService {
    mstVisit: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'mst_visit/list/?';
    private AddRecord = webapi + 'mst_visit/create';
    private EditRecord = webapi + 'mst_visit/update';
    private GetRecord = webapi + 'mst_visit/byid/';
    private referToDept = webapi + 'mst_visit/referto/';
    private GetRecordpatient = webapi + 'mst_visit/visitbypatientidsearch/';
    private DeleteRecord = webapi + 'mst_visit/delete/';
    private lastvisitautocomplete = webapi + 'mst_visit/lastvisitautocomplete?'; //  mohit
    private GetRecordbypatient = webapi + 'mst_visit/bypatientid/';
    private GetEmrPatientList = webapi + 'mst_visit/byEmrpatientid/';
    private lastvisitautocompleteMR = webapi + 'mst_visit/lastvisitautocompleteMR?'; //  Jay
    private lastvisitautocompleteName = webapi + 'mst_visit/lastvisitautocompleteName?'; //  Jay
    private lastvisitautocompletePhone = webapi + 'mst_visit/lastvisitautocompletePhone?'; //  Jay
    private lastvisitautocompleteMobile = webapi + 'mst_visit/lastvisitautocompleteMobile?'; //  Jay
    private lastvisitautocompleteID = webapi + 'mst_visit/lastvisitautocompleteID?'; //  Jay
    private lastvisitautocompleteEmail = webapi + 'mst_visit/lastvisitautocompleteEmail?'; //  Jay
    private LastEposide = webapi + 'mst_visit/lasteposide/';  //  last Eposide
    private GetLastVisit = webapi + 'mst_visit/getLastVisit/';  //  last Eposide
    private lastvisitautocompleteById = webapi + 'mst_visit/lastvisitautocompleteById?';
    private lastvisitautocompleteByIdbyDto = webapi + 'mst_visit/lastvisitautocompletebyidbydto?';
    private NewBorn = webapi + 'mst_visit/findbynewborn?';
    private IsBroughtDead = webapi + 'mst_visit/findByIsBroughtDead?';
    private GetVisitByPatientIdOfIpdPatient = webapi + 'mst_visit/getVisitByPatientIdOfIpdPatient/';
    private GetVisitAndTimelineByPatientId = webapi + 'mst_visit/getVisitAndTimelineByPatientId/';
    private SearchRecordByAdmissionUnitId = webapi + 'trn_admission/searchadmissionByUnitId/?';
    private SearchRecordByAutoMrAdmissionUnitId = webapi + 'trn_admission/searchadmissionByautocompleteMRUnitId/?';
    private SearchRecordByAutoNameAdmissionUnitId = webapi + 'trn_admission/searchadmissionByautocompleteNameUnitId/?';
    private SearchRecordByAutoIdAdmissionUnitId = webapi + 'trn_admission/searchadmissionByautocompleteIDUnitId/?';
    private SearchRecordByAutoPhoneAdmissionUnitId = webapi + 'trn_admission/searchadmissionByautocompletePhoneUnitId/?';
    private SearchRecordByAutoEmailAdmissionUnitId = webapi + 'trn_admission/searchadmissionByautocompleteEmailUnitId/?';
    private SearchRecordByAutoMobileAdmissionUnitId = webapi + 'trn_admission/searchadmissionByautocompleteMobileUnitId/?';
    private lastvisitfortariff = webapi + 'mst_visit/visitbypatientid/';
    private addNewVisitLink = webapi + 'mst_visit/addNewVisit';
    private CreateEmergencyPatient = webapi + 'mst_visit/createEmergencyPatient';
    private update_appointment = webapi + 'trn_appointment/updateAppointmentConfirmation/';
    private update_trnAdmissionRequest = webapi + 'trn_admission_request/updateAdmissionrequestIsConfirmed/';
    private GetSerachAutoCompleteEMRPatient = webapi + 'mst_visit/patientsearchByAll/';                            //Neha
    private getReferDeptByVisitId = webapi + 'patient_visit_dept/byvisitid/';//vishal
    private visitCountByPatientId = webapi + 'mst_visit/getVisitCount/'; //Nayan
    private loadTokenData = webapi + 'mst_visit/gettokenbystaff/';



    constructor(
        private http: Http
    ) {
    }



    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getReferDeptByVisit(visitId: any): Promise<any> {
        return this.http.get(this.getReferDeptByVisitId + visitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    //  Author : Mohit
    getLastRecordForAutoAll(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocomplete + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoMR(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteMR + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoName(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteName + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoPhone(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompletePhone + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoMobile(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteMobile + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoID(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteID + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoEmail(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteEmail + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    getLastRecordForAutoAllById(qString: any, unitId: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteById + 'searchString=' + qString + '&unitId=' + unitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    getLastRecordForAutoAllByIdByDTO(qString: any, unitId: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteByIdbyDto + 'searchString=' + qString + '&unitId=' + unitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getrecordbyvisit(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getrecordbypatientidlastvisit(id: any) {
        return this.http.get(this.lastvisitfortariff + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    referTodetpartment(visitId: any, departmentId: any, subDeaprtmentId: any, staffId: any, tbillserviceId: any) {
         return this.http.get(this.referToDept + "?visitId=" + visitId + "&departmentId=" + departmentId + '&subDeaprtmentId=' + subDeaprtmentId + "&staffId=" + staffId + "&tbillserviceId=" + tbillserviceId )
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getRecordServicebypatientid(id: any) {
        // console.log(this.GetRecord + id);
        return this.http.get(this.GetRecordpatient + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getLastEposideService(lastEposideId: any, visitRegistrationSource: any) {
        return this.http.get(this.LastEposide + lastEposideId + '/' + visitRegistrationSource)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getLastVisitService(patientID: any) {
        return this.http.get(this.GetLastVisit + patientID)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getrecordbypatient(id: any) {
        return this.http.get(this.GetRecordbypatient + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getEmrPatientList(id: any) {
        return this.http.get(this.GetEmrPatientList + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // Author : Romil
    getNewBornAutoComplete(qString: any) {
        return this.http.get(this.NewBorn + 'searchString=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // Author : Romil
    getIsBroughtDeadAutoComplete(qString: any) {
        // console.log(qString);
        return this.http.get(this.IsBroughtDead + 'searchString=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getVisitByPatientIdOfIpdPatient(patientId: any, patientSource: any) {
        return this.http.get(this.GetVisitByPatientIdOfIpdPatient + patientId + '/' + patientSource)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getVisitAndTimelineByPatientId(id: any, currentPage: any, size: any) {
        // console.log(this.GetRecord + id);
        return this.http.get(this.GetVisitAndTimelineByPatientId + id + '/' + currentPage + '/' + size)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchRecordServiceByAddmissinAndUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAdmissionUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

 // GS
    searchRecordServiceByAutoMRAddmissinUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAutoMrAdmissionUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    searchRecordServiceByAutoNameAddmissinUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAutoNameAdmissionUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    searchRecordServiceByAutoPhoneAddmissinUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAutoPhoneAdmissionUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchRecordServiceByAutoMobileAddmissinUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAutoMobileAdmissionUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchRecordServiceByAutoIDAddmissinUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAutoIdAdmissionUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getLastRecordForAutoEmailAddmissinUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAutoEmailAdmissionUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // end


    addNewVisitRecordService(model: any) {
        return this.http.put(this.addNewVisitLink, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    addEmergencyPatientRecordService(model: any) {
        return this.http.put(this.CreateEmergencyPatient, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    // Method By chetan for Avoid Duplication record
    updateAppointment(id: any) {
        return this.http.get(this.update_appointment + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updateAdmissionRequest(id: any) {
        return this.http.get(this.update_trnAdmissionRequest + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    getmrnofnamelnameAutocomplete(mrno: any, unitId: any): Promise<any> {
        return this.http.get(this.GetSerachAutoCompleteEMRPatient + mrno + '/' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getvisitCountByPatientId(patientId: any): Promise<any> {
        return this.http.get(this.visitCountByPatientId + patientId )
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    loadTodayToken(staffList) {
        return this.http.get(this.loadTokenData + staffList )
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }

    private logError(error: Response | any) {
        return Observable.throw(error.message || error);
    }

}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-visit/mst-visit.service.ts